import styled from '@emotion/styled';

import Header from 'components/Header';
import Home from 'pages/Home/Home';
import Footer from 'components/Footer/Footer';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function App() {
  return (
    <Root>
      <Header />
      <Home />
      <Footer />
    </Root>
  );
}

const Root = styled.div`
  background: #F5F7F8;
  
  h1 {
    font-family: 'Noto Sans TC';
    font-style: normal;
    font-weight: 700;
    margin: 0;
    padding: 0;
  }

  h2 {
    font-family: 'Noto Sans TC';
    font-style: normal;
    font-weight: 700;
    margin: 0;
    padding: 0;
  }

  h3 {
    font-family: 'Noto Sans TC';
    font-style: normal;
    font-weight: 500;
    margin: 0;
    padding: 0;
  }

  h4 {
    font-family: 'Noto Sans TC';
    font-style: normal;
    font-weight: 500;
    margin: 0;
    padding: 0;
  }

  h5 {
    font-family: 'Noto Sans TC';
    font-style: normal;
    font-weight: 500;
    margin: 0;
    padding: 0;
  }

  h6 {
    font-family: 'Noto Sans TC';
    font-style: normal;
    font-weight: 400;
    margin: 0;
    padding: 0;
  }

  p {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 600;
    margin: 0;
    padding: 0;
  }

  a {
    text-decoration: none;
    font-family: 'Noto Sans TC';
    font-style: normal;
    font-weight: 400;
    cursor: pointer;
  }

  button {
    font-family: 'Noto Sans TC';
    font-style: normal;
    font-weight: 400;
    transform: all 0.25s ease-in-out;
  }

  ul {
    margin: 0;
    padding: 0;
  }

  li {
    list-style-type: none;
  }
`;

export default App;